<template>
  <header>
    <div class="inner-navbar">
      <a href="#/" class="brand-link">pulseData</a>
      <div class="nav-items">
        <slot></slot>
        <ApplicationMenu />
        <Avatar />
      </div>
    </div>
  </header>
</template>

<script>
import Avatar from 'shared_ui_components/src/auth/Avatar'
import ApplicationMenu from 'shared_ui_components/src/application_menu/ApplicationMenu'

export default {
  name: 'NavBar',
  components: {Avatar, ApplicationMenu},
  props: [],
  data () {
    return {}
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  header {
    height: 60px;
  }

  .inner-navbar {
    height: calc(100% - 14px);
    margin-bottom: 4px;
    background: #409EFF;
    align-items: center;
    justify-content: space-between;
    padding: 10px 8px 0;
    box-shadow: 0px 3px 5px rgba(100, 100, 100, 0.49);
  }

  .brand-link {
    font-family: opificio, hanken;
    color: white;
    font-size: 24px;
    text-decoration: none;
    float: left;
  }

  .nav-items {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .nav-items > * {
    margin-left: 16px;
  }

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue